module.exports = __webpack_public_path__ + "img/shenzhen.9bcb5f0a.jpg";